/**
 * Created by Administrador on 01/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('flightParameters', {
                parent: 'app',
                url: '/flightParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/parameter/flightParameters.html',
                        controller: 'parameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabParameters': ['tabService', function(tabService){
                                return tabService.getTabParameter('flightParameters');
                            }],
                            translatePartialLoader: ['translationHandler', function(translationHandler) {
                                return translationHandler.translateRefresh(['parameter']);
                            }],
                            parameters: ['parameterService',function(parameterService){
                                return parameterService.getParametersByGroupParameter(1);
                            }]
                        }
                    }
                }
            })
            .state('saleReservationParameters', {
                parent: 'app',
                url: '/saleReservationParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/parameter/saleReservationParameters.html',
                        controller: 'parameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabParameters': ['tabService', function(tabService){
                                return tabService.getTabParameter('saleReservationParameters');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['parameter']);
                            }],
                            parameters: ['parameterService',function(parameterService){
                                return parameterService.getParametersByGroupParameter(2);
                            }]
                        }
                    }
                }
            })
            .state('checkInParameters', {
                parent: 'app',
                url: '/checkInParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/parameter/checkInParameters.html',
                        controller: 'parameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabParameters': ['tabService', function(tabService){
                                return tabService.getTabParameter('checkInParameters');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['parameter']);
                            }],
                            parameters: ['parameterService',function(parameterService){
                                return parameterService.getParametersByGroupParameter(3);
                            }]
                        }
                    }
                }
            })
            .state('externalChannelsParameters', {
                parent: 'app',
                url: '/externalChannelsParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/parameter/externalChannelsParameters.html',
                        controller: 'parameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabParameters': ['tabService', function(tabService){
                                return tabService.getTabParameter('externalChannelsParameters');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['parameter']);
                            }],
                            parameters: ['parameterService',function(parameterService){
                                return parameterService.getParametersByGroupParameter(4);
                            }]
                        }
                    }
                }
            })
            .state('noShowParameters', {
                parent: 'app',
                url: '/noShowParameters',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/parameter/noShowParameters.html',
                        controller: 'parameterCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabParameters': ['tabService', function(tabService){
                                return tabService.getTabParameter('noShowParameters');
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['parameter']);
                            }],
                            parameters: ['parameterService',function(parameterService){
                                return parameterService.getParametersByGroupParameter(5);
                            }]
                        }
                    }
                }
            })
    }
})();
